<template>

  <!-- Completed (CANCELED) -->
  <route-list-data-table
      title="Canceled"
      defaultSortField="canceled_at"
      defaultSortOrder="dsc"
      :myRoutes="true"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      routeClickGoTo="route-info" />

</template>

<script>
import RouteListDataTable from '@/components/routes/RouteListDataTable'

export default {
  name: 'DeliveryListCanceledPage',

  components: {
    RouteListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name', width: '180px' },
        { text: 'Orders', sortable: false, value: 'orders', width: '170px' },
        { text: 'Delivery Date', value: 'delivery_date' },
        { text: 'Driver', value: 'driver_user_id' },
        { text: 'Vehicle', value: 'vehicle_id' },
        { text: 'Canceled', value: 'canceled_at' },
        { text: 'Status', value: 'route_status' }
      ],
      status: ['CANCELED'],
      assocs: 'orders,driver,vehicle'
    }
  }
}
</script>

<style scoped>
</style>
